import { motion } from "framer-motion";
import moment from "moment";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

const PreauthProviderMedical = () => {
  const { viewPreauthorizationInfo } = useSelector(
    (state) => state.preauthorization
  );

  const preauthMedicalDetails =
    viewPreauthorizationInfo?.provider_request?.medical_details;

  return (
    <motion.div
      style={{ border: "2px solid #d9f8eb" }}
      className="rounded p-3 position-relative mt-3 mb-3"
      initial={{ opacity: 0, y: 50 }} // Starts faded out and moved down
      animate={{ opacity: 1, y: 0 }} // Fades in and moves to place
      exit={{ opacity: 0, y: 50 }} // Optional: for exit animation
      transition={{ duration: 0.5 }} // Smooth transition
    >
      {/* Floating Badge Header */}
      <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-11">Medical Details</span>
        </span>
      </div>
      <Row>
        <Col xs={12}>
          {/* Chief Complaint */}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">Chief Complaint</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">
                {preauthMedicalDetails?.chiefcomplaint}
              </span>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">
                Aspects Of Condition (Onset)
              </span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">
                {preauthMedicalDetails?.onset ? `(${preauthMedicalDetails?.onset}) - ` : ''} {preauthMedicalDetails?.onsetdate ? moment(preauthMedicalDetails?.onsetdate).format('DD-MM-YYYY') : ''}
              </span>
            </Col>
          </Row>
          <hr />

          {/* Significant Signs */}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">Significant Signs</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">
                {preauthMedicalDetails?.significantsigns}
              </span>
            </Col>
          </Row>
          <hr />

          {/* Other Conditions */}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">Other Conditions</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">
                {preauthMedicalDetails?.otherconditions}
              </span>
            </Col>
          </Row>
          <hr />

          {/* Clinical Data */}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">Clinical Data</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">
                {preauthMedicalDetails?.clinicaldata}
              </span>
            </Col>
          </Row>
          <hr />

          {/* Treatment Plan */}
          {preauthMedicalDetails?.missingtooth?.tooth_no && (
            <>
              <Row>
                <Col xs={12} md={3}>
                  <span className="fs-10 fw-bold">Missing Tooth</span>
                </Col>
                <Col xs={12} md={9}>
                  <Row className="fs-10 fw-normal text-800">
                    <Col xs={4}>Number : {preauthMedicalDetails?.missingtooth?.tooth_no}</Col>
                    <Col xs={4}>Date : {preauthMedicalDetails?.missingtooth?.date ? moment(preauthMedicalDetails?.missingtooth?.date).format('DD-MM-YYYY') : ''}</Col>
                    <Col xs={4}>Reason: {preauthMedicalDetails?.missingtooth?.desc}</Col>
                  </Row>
                </Col>
              </Row>
              <hr />
            </>
          )}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">Treatment Plan</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">
                {preauthMedicalDetails?.treatmentplan}
              </span>
            </Col>
          </Row>
          <hr />

          {/* Patient History */}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">Patient History</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">
                {preauthMedicalDetails?.patienthistory}
              </span>
            </Col>
          </Row>
          <hr />

          {/* Physical Examination */}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">Physical Examination</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">
                {preauthMedicalDetails?.physicalexamination}
              </span>
            </Col>
          </Row>
          <hr />

          {/* History Of Present Illness */}
          <Row>
            <Col xs={12} md={3}>
              <span className="fs-10 fw-bold">History Of Present Illness</span>
            </Col>
            <Col xs={12} md={9}>
              <span className="fs-10 fw-normal text-800">
                {preauthMedicalDetails?.historypresentillness}
              </span>
            </Col>
          </Row>
        </Col>
      </Row>
    </motion.div>
  );
};

export default PreauthProviderMedical;
